import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Badge } from '../ui/badge';
import { ScrollArea } from '../ui/scroll-area';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';
import { CheckCircle2, XCircle, Clock, AlertTriangle } from 'lucide-react';

export const TestResultDialog = ({ open, onOpenChange, testResult }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[80vh] overflow-hidden flex flex-col">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            {testResult?.success ? (
              <CheckCircle2 className="h-5 w-5 text-green-500" />
            ) : (
              <XCircle className="h-5 w-5 text-red-500" />
            )}
            Resultado de la Prueba
          </DialogTitle>
        </DialogHeader>
        
        <ScrollArea className="flex-1">
          {testResult && (
            <div className="space-y-4">
              <div className="flex items-center gap-4">
                <Badge variant={testResult.success ? 'default' : 'destructive'}>
                  {testResult.success ? 'Exitoso' : 'Fallido'}
                </Badge>
                <span className="text-sm text-gray-500">
                  <Clock className="h-4 w-4 inline mr-1" />
                  {testResult.duration_ms}ms
                </span>
                {testResult.response?.status_code && (
                  <Badge variant="outline">
                    Status: {testResult.response.status_code}
                  </Badge>
                )}
              </div>
              
              {testResult.error && (
                <div className="p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
                  <AlertTriangle className="h-4 w-4 inline mr-2" />
                  {testResult.error}
                </div>
              )}
              
              <Accordion type="multiple" defaultValue={['request', 'response']}>
                <AccordionItem value="request">
                  <AccordionTrigger>Request</AccordionTrigger>
                  <AccordionContent>
                    <div className="space-y-2 text-sm">
                      <p><strong>URL:</strong> {testResult.request?.url}</p>
                      <p><strong>Method:</strong> {testResult.request?.method}</p>
                      <div>
                        <strong>Headers:</strong>
                        <pre className="bg-gray-100 p-2 rounded mt-1 text-xs overflow-x-auto">
                          {JSON.stringify(testResult.request?.headers, null, 2)}
                        </pre>
                      </div>
                      {testResult.request?.body && (
                        <div>
                          <strong>Body:</strong>
                          <pre className="bg-gray-100 p-2 rounded mt-1 text-xs overflow-x-auto">
                            {JSON.stringify(testResult.request?.body, null, 2)}
                          </pre>
                        </div>
                      )}
                    </div>
                  </AccordionContent>
                </AccordionItem>
                
                <AccordionItem value="response">
                  <AccordionTrigger>Response</AccordionTrigger>
                  <AccordionContent>
                    {testResult.response ? (
                      <div className="space-y-2 text-sm">
                        <p><strong>Status:</strong> {testResult.response.status_code}</p>
                        <div>
                          <strong>Body:</strong>
                          <pre className="bg-gray-100 p-2 rounded mt-1 text-xs overflow-x-auto max-h-64">
                            {typeof testResult.response.body === 'object' 
                              ? JSON.stringify(testResult.response.body, null, 2)
                              : testResult.response.body}
                          </pre>
                        </div>
                      </div>
                    ) : (
                      <p className="text-gray-500">Sin respuesta</p>
                    )}
                  </AccordionContent>
                </AccordionItem>
              </Accordion>
            </div>
          )}
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};

export default TestResultDialog;
